import { PublicLinkObjectType } from '@flicent/fieldpulse-react-component-library-frontend';

export const CUSTOM_FORM_OBJECT_TYPE_TO_ANALYTICS_RECORD_TYPE: Record<PublicLinkObjectType, string> = {
  'App\\Http\\Api\\Core\\Models\\BaseCustomForm': 'custom_form',
  'App\\Http\\Api\\Core\\Models\\BaseJob': 'job',
  'App\\Http\\Api\\Core\\Models\\BaseSubTask': 'subtask',
  'App\\Http\\Api\\Core\\Models\\BaseUser': 'user',
  'App\\Http\\Api\\Core\\Models\\BaseFile': 'file',
  'App\\Http\\Api\\Core\\Models\\BaseAsset': 'asset',
  'App\\Http\\Api\\Core\\Models\\BaseInvoice': 'invoice',
  'App\\Http\\Api\\Core\\Models\\BaseCustomer': 'customer',
  'App\\Http\\Api\\Core\\Models\\VariantProposal\\BaseVariantProposal': 'variant_proposal',
  'App\\Http\\Api\\Core\\Models\\DetailedProposal\\BaseDetailedProposal': 'detailed_proposal',
  'App\\Modules\\Schedule\\Models\\BaseProject': 'project',
  'App\\Modules\\MaintenanceAgreement\\Models\\BaseMaintenanceAgreement': 'maintenance_agreement',
  'App\\Modules\\Contracts\\Models\\BaseEntityContract': 'entity_contract',
};